// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1QCIm","sendOtp":"AuthorizeToLogin_sendOtp__3LI4h"};